import {useState, useRef, useEffect} from "react";


interface Turn {
    user_prompt: string;
    bot_response: string;
}

export default function Interview() {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const [history, setHistory] = useState<Turn[]>([]);
    const [input, setInput] = useState("");
    const bottomRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        bottomRef.current?.scrollIntoView({behavior: "smooth"});
    }, [history]);

    const handleSend = () => {
        const trimmed = input.trim();
        if (!trimmed) return;

        // TODO: call your backend here instead of this dummy response
        const mockBotResponse = "This is where the bot’s reply will go.";

        setHistory(prev => [
            ...prev,
            {
                user_prompt: trimmed,
                bot_response: trimmed.toUpperCase(),
            },
        ]);

        setInput("");
    };

    return (
        <div className="flex h-screen bg-bg text-text">
            {/* Main column */}
            <div className="flex flex-col flex-1">
                {/* Header */}
                <header className="flex items-center justify-between
                                   bg-header text-white
                                   px-6 py-4 shadow">
                    <div>
                        <h2 className="text-xl font-semibold">Dimension Name</h2>
                        <div className="text-sm text-bg/70">
                            User / Customer Info
                        </div>
                    </div>

                    <button
                        onClick={() => setSidebarOpen(!sidebarOpen)}
                        className="text-sm rounded
                                   bg-accent hover:bg-accentHover
                                   text-white px-3 py-1 shadow"
                    >
                        {sidebarOpen ? "Hide Details" : "Show Details"}
                    </button>
                </header>

                {/* Static section */}
                <div className="max-h-[150px] overflow-y-auto
                                border-b border-border
                                px-6 py-3 bg-white">
                    <p>This is the static dimension description text...</p>
                </div>

                {/* Chat area */}
                <div className="flex-1 flex flex-col overflow-y-auto bg-white">
                    {/* Messages */}
                    <div className="flex-1 overflow-y-auto p-6 space-y-4">
                        {history.length === 0 && (
                            <p className="text-text/60 text-sm">
                                Chat goes here…
                            </p>
                        )}

                        {history.map((turn, index) => (
                            <div key={index} className="space-y-2">
                                {/* User bubble */}
                                <div className="flex justify-end">
                                    <div
                                        className="
                                              inline-block
                                              max-w-[70%]
                                              rounded-lg
                                              bg-accent
                                              text-white
                                              px-3
                                              py-2
                                              text-sm
                                              whitespace-normal
                                              break-all
                                            "
                                    >
                                        {turn.user_prompt}
                                    </div>
                                </div>

                                {/* Bot bubble */}
                                <div className="flex justify-start">
                                    <div
                                        className="
                                                  inline-block
                                                  max-w-[70%]
                                                  rounded-lg
                                                  bg-bg
                                                  text-text
                                                  px-3
                                                  py-2
                                                  text-sm
                                                  whitespace-normal
                                                  break-words
                                                  border
                                                  border-border
                                                  break-all
                                                "
                                    >
                                        {turn.bot_response}
                                    </div>
                                </div>
                            </div>
                        ))}


                        {/* scroll anchor */}
                        <div ref={bottomRef}/>
                    </div>

                    {/* Input row */}
                    <div className="border-t border-border px-4 py-3 bg-bg flex items-center gap-2">
                        <input
                            type="text"
                            value={input}
                            onChange={e => setInput(e.target.value)}
                            onKeyDown={e => {
                                if (e.key === "Enter" && !e.shiftKey) {
                                    e.preventDefault();
                                    handleSend();
                                }
                            }}
                            placeholder="Type your question about this dimension…"
                            className="flex-1 rounded border border-border px-3 py-2 text-sm
                 focus:outline-none focus:ring-2 focus:ring-accent/60 focus:border-accent"
                        />
                        <button
                            onClick={handleSend}
                            className="text-sm rounded bg-accent hover:bg-accentHover
                 text-white px-4 py-2 whitespace-nowrap"
                        >
                            Send
                        </button>
                    </div>
                </div>
            </div>

            {/* Sidebar */}
            {sidebarOpen && (
                <aside className="w-[320px] bg-bg
                                  border-l border-border
                                  px-5 py-4 overflow-y-auto">
                    <h3 className="text-text font-semibold mb-2 text-sm">
                        Current Rank Estimate
                    </h3>
                    <div className="mb-4 text-sm text-text/80">
                        [hidden or shown based on mode]
                    </div>

                    <h3 className="text-text font-semibold mb-2 text-sm">
                        Fact Summary
                    </h3>
                    <ul className="space-y-1 text-sm text-text">
                        <li>• Fact 1</li>
                        <li>• Fact 2</li>
                        <li>• Fact 3</li>
                    </ul>
                </aside>
            )}
        </div>
    );
}
